<div class="tb-navbar uk-padding-left uk-padding-right" uk-navbar>
  <div [routerLink]="['']" class="uk-navbar-left pointer uk-flex-middle">
    <div class="toolbar-img">
      <img alt="logo" src="../../../assets/images/landing-page/tess-logo.png" />
    </div>
    <h3 class="toolbar-title">Travel eSolutions Builder</h3>
  </div>
  <div class="uk-grid-small uk-navbar-right">
    <ul class="uk-navbar-nav uk-visible@m"></ul>
  </div>
</div>
